import { useCallback } from 'react';

import { useWizardService, WIZARD_EVENTS } from '@bingads-webui-react/wizard';
import { AdFormat } from '@bingads-webui-campaign-react/display-plus-native-ads';

// Specific to multi ad format in native campaign
export const useSelectedAdFormatState = () => {
  const { state: wizardState, send: wizardSend } = useWizardService();
  const updateSelectedAdFormat = useCallback(value => wizardSend(WIZARD_EVENTS.UPDATE_WIZARD_DATA, { selectedAdFormat: value }), [wizardSend]);

  return [
    wizardState.context.wizardData.selectedAdFormat || AdFormat.Native,
    updateSelectedAdFormat,
  ];
};
